import { upperFirst } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import render from './render'

export default function(options) {
  return {
    name: options.path.split('.').map(upperFirst).join(''),

    props: {
      settings: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },

    computed: {
      schema() {
        const result = {
          events: {
            me: [],
            child: []
          },
          other: []
        }

        for (const key in options.keys) {
          // https://sigmasms.slack.com/archives/DDQ6HS91D/p1753963541666309?thread_ts=1753960887.431369&cid=DDQ6HS91D
          if (key === 'notifications.events.billings.limit') {
            continue
          }
          const [ service, group ] = key.split('.')
          if (service === Services.notifications) {
            switch (group) {
              case 'events': {
                result.events.me.push(key)
                break
              }
              case 'childrenUsersEvents': {
                result.events.child.push(key)
                break
              }
              default: {
                result.other.push(key)
                break
              }
            }
          }
        }

        return result
      }
    },

    render(h) {
      return render.call(this, h, options)
    }
  }
}
